import React, { useState } from 'react';

// "Como funciona o atendimento" — documentacao viva da tela de Atendimentos.
// Editar o conteudo aqui (ABAS / SECOES / FluxogramaSVG) reflete no botao "i".
// Regra: o texto tem que bater com o comportamento REAL do sistema. Quando
// mudar regra de fila/filtro/acao, atualize aqui junto.

const VERDE = '#3D8B37';
const LARANJA = '#F5A623';

// Negrito simples: *assim* vira <strong>assim</strong>.
function Rico({ texto }) {
  const partes = String(texto).split(/(\*[^*]+\*)/g);
  return (
    <>
      {partes.map((p, i) => (p.startsWith('*') && p.endsWith('*') && p.length > 2
        ? <strong key={i}>{p.slice(1, -1)}</strong>
        : <React.Fragment key={i}>{p}</React.Fragment>))}
    </>
  );
}

// ---------------------------------------------------------------- conteudo --

const SECOES = {
  fluxo: [
    {
      titulo: '1. O cliente manda mensagem',
      icone: 'bi-chat-left-text',
      itens: [
        'Todo atendimento começa com o cliente falando no WhatsApp do canal (o número da loja).',
        'Se o canal tem um *fluxo do bot publicado e ativo*, o bot conduz um menu curto no próprio WhatsApp ("1 Caixa, 2 Crediário") e encaminha pra fila certa.',
        'Se o canal *não* tem fluxo (ou o bot está desligado), a conversa cai direto na *fila padrão do canal* — sem menu nenhum pro cliente.',
        'Contato marcado como *"pular o bot"* (ex.: telefone de vendedor) não passa pelo menu: vai direto pra fila configurada no cadastro dele.',
      ],
    },
    {
      titulo: '2. A conversa entra numa fila (setor)',
      icone: 'bi-inboxes',
      itens: [
        'A hierarquia é: *canal* (um número de WhatsApp) → *fila* (Caixa, Crediário, Vendas) → *atendente*.',
        'Cada fila pertence a *um canal*. Duas filas com o mesmo nome em canais diferentes são filas diferentes, com atendentes e configuração próprios.',
        'A fila é o que decide *quem enxerga* a conversa. Você vê apenas as filas liberadas pra você; o gestor vê todas.',
        'Conversa que ainda não caiu em fila nenhuma fica no *pendente-geral* e aparece pra quem tem acesso, pra alguém pegar.',
      ],
    },
    {
      titulo: 'Roteamento configurado no contato',
      icone: 'bi-signpost-split',
      itens: [
        'Em *Contatos* dá pra dizer, por cliente e por canal, pra onde a mensagem dele vai — do mais específico pro mais amplo:',
        '*Atendente padrão* (mais específico) — "esse cliente é do vendedor Fulano": cai direto nele.',
        '*Fila padrão* (mais amplo) — "esse cliente cai sempre no Caixa": entra na fila e segue a distribuição dela.',
        '*Pular o bot* (complemento) — pra quem não tem nenhum dos dois: não vê o menu e cai na fila padrão do canal.',
        'Quem tem atendente ou fila padrão *já não passa pelo menu do bot* — se o Fio sabe pra onde mandar, não faz sentido perguntar ao cliente.',
      ],
    },
    {
      titulo: '3. O sistema tenta entregar sozinho',
      icone: 'bi-magic',
      itens: [
        'Atenção: isto só acontece *depois* que a conversa já entrou numa fila (passo 2). Uma fila em modo automático não puxa conversa que está *sem fila* — se o canal não tem bot nem fila padrão, a conversa fica parada no Pendente por mais automática que a fila seja.',
        'Fila *automática*: o sistema já entrega a conversa pro atendente da fila que estiver *Disponível* e com *menos conversas abertas* (respeitando o teto configurado). Ela nasce direto na *Minha fila* dessa pessoa.',
        'Fila *colaborativa (manual)*: ninguém recebe automaticamente — a conversa fica no *Pendente* e quem estiver livre pega. É o desenho pra vendas, por exemplo.',
        'Se ninguém está Disponível (todo mundo Ausente/offline) ou todos bateram o teto, a conversa fica no *Pendente* esperando.',
        'Quando você volta de *Ausente* pra *Disponível*, o sistema *puxa automaticamente* os pendentes das suas filas automáticas — os mais antigos primeiro.',
      ],
    },
    {
      titulo: '4. Atendente responde',
      icone: 'bi-headset',
      itens: [
        '*Responder assume a conversa que ainda não tem dono* — não precisa clicar em "Assumir" antes. Se a conversa *já é de um colega*, responder NÃO tira ela dele: sua mensagem sai pro cliente e a conversa continua na fila de quem estava atendendo. É assim que o gerente entra pra ajudar sem sumir com a conversa da atendente.',
        'A partir do momento em que alguém assume, o bot fica em silêncio naquela conversa: tudo que o cliente mandar vai direto pro atendente.',
      ],
    },
    {
      titulo: '5. Encerrar e reabrir',
      icone: 'bi-check2-circle',
      itens: [
        'A conversa *nunca encerra sozinha* — alguém precisa encerrar pelo ⋮ → *Encerrar*. Se a loja usar motivos de encerramento, ele pergunta o motivo; senão encerra num clique.',
        'Se o cliente voltar a falar depois de encerrada, ela *reabre sozinha*: solta o atendente anterior, volta pro Pendente e passa pelo bot de novo (se houver fluxo).',
        'Você também pode reabrir: é só abrir a conversa encerrada e mandar mensagem.',
      ],
    },
  ],

  tela: [
    {
      titulo: 'As 3 visões (chips do topo da lista)',
      icone: 'bi-ui-radios',
      itens: [
        '*Minha fila* — as conversas que estão com você. É onde você trabalha o dia todo.',
        '*Pendente* — as duas coisas juntas: *ninguém é dono* e a *última mensagem é do cliente*. Ou seja: tem gente esperando resposta. Só mostra as filas que você enxerga; o número vermelho é quantas estão esperando.',
        '*Encerradas* — as suas conversas já encerradas (histórico).',
        'São modos exclusivos: clicou num, sai do outro.',
      ],
    },
    {
      titulo: '"Ver junto" — camadas somadas à Minha fila',
      icone: 'bi-layers',
      itens: [
        'Aparece só quando você está em *Minha fila*. Serve pra *somar* conversas por cima da sua lista, sem trocar de visão. Dá pra ligar as duas ao mesmo tempo.',
        '*Por fora* — conversas sem dono em que *a loja falou por último*: alguém respondeu pelo celular ou pelo WhatsApp Web. Não é pendência (o cliente não está esperando), mas vale acompanhar pra ninguém responder em dobro. Assim que o cliente responder, ela passa pro Pendente.',
        '*Time* — as conversas que estão com os colegas. Nas filas colaborativas você vê o time; o gestor vê todo mundo.',
      ],
    },
    {
      titulo: 'Filtros (botão de controles)',
      icone: 'bi-sliders',
      itens: [
        'Os filtros *estreitam* o que já está na lista — eles não trazem conversa nova.',
        '*Fila* — chips (Todas, Caixa, Crediário…). O número vermelho ao lado é quanta gente está esperando resposta naquela fila.',
        '*Canal* — só aparece se você atende mais de um número. A escolha fica salva pra próxima vez que você entrar.',
        '*Atendente* — só pra quem tem papel de gestão, pra olhar a fila de uma pessoa específica.',
        'A busca de cima procura por *nome, número ou texto da mensagem* em todas as conversas da visão atual.',
      ],
    },
    {
      titulo: 'A ordem da lista não é aleatória',
      icone: 'bi-sort-down',
      itens: [
        '1º — conversas *fixadas* (📌), sempre no topo.',
        '2º — quem está *esperando resposta*, e entre essas, quem espera há *mais tempo* vem primeiro.',
        '3º — o resto, por mensagem mais recente.',
      ],
    },
    {
      titulo: 'O topo da tela',
      icone: 'bi-window',
      itens: [
        '*Equipe* — chat interno entre funcionários. Não vai pro cliente, é conversa da loja.',
        '*Grupos* — os grupos de WhatsApp do canal, numa tela separada (não se misturam com o atendimento 1:1).',
        '*Contatos* — cadastro dos clientes (nome, filial, fila do contato, pular o bot).',
        '*Nova conversa* — você começa a falar com alguém: escolhe o contato (ou cadastra na hora) e manda a primeira mensagem.',
        'Na barra lateral do sistema tem o seu status *Disponível / Ausente*. Ausente = você não recebe conversa nova automaticamente (use no almoço, na reunião).',
      ],
    },
  ],

  selos: [
    {
      titulo: 'O que cada selo da conversa quer dizer',
      icone: 'bi-tags',
      tabela: [
        ['📌 alfinete', 'Conversa fixada — fica presa no topo da lista até você desafixar.'],
        ['Número laranja', 'Quantas mensagens do cliente ainda não foram lidas. *Zera* quando a conversa é aberta — aqui ou no celular. A conversa continua na lista.'],
        ['Bolinha laranja', 'Você marcou a conversa como *não-lida* de propósito, pra voltar nela depois. É um lembrete só seu — o cliente não vê nada.'],
        ['⏱ tempo (cinza/laranja/vermelho)', 'Há quanto tempo o cliente está esperando resposta. Cinza < 1min, laranja 1–5min, vermelho > 5min.'],
        ['Aberta / Em atendimento / Encerrada', 'Situação da conversa. "Em atendimento" = alguém assumiu.'],
        ['🗂 nome da fila', 'Em qual fila (setor) a conversa está.'],
        ['👤 nome', 'Quem é o dono da conversa hoje.'],
        ['📱 pelo celular', 'A última mensagem foi da loja, mandada por fora do Fio (aparelho ou WhatsApp Web). O cliente não está esperando — mas confira antes de responder, pra não falar em dobro.'],
        ['Cronômetro do SLA', 'Prazo da *primeira resposta* e, depois, da *solução*. Conta só dentro do horário de atendimento — fora do horário ele congela.'],
      ],
    },
  ],

  responder: [
    {
      titulo: 'Escrever e enviar',
      icone: 'bi-keyboard',
      itens: [
        '*Enter* envia. *Shift+Enter* quebra linha.',
        'Trocou de conversa no meio de um texto? O *rascunho fica guardado* naquela conversa e volta quando você abrir de novo.',
        'Se a conversa ainda não tem dono, aparece o aviso "ao responder, você assume esta conversa" — é exatamente o que acontece.',
        'Se um colega já assumiu, aparece *"Em atendimento por fulano"*. Você ainda pode escrever e anexar — e a conversa *continua com ele*. Só o botão *Assumir pra mim* transfere de verdade; use quando for realmente tomar a conversa (aí ela sai da fila do colega e entra na sua).',
      ],
    },
    {
      titulo: 'Respostas rápidas',
      icone: 'bi-lightning-charge',
      itens: [
        'Botão de *raio (⚡)* ao lado do campo, ou digite */atalho* (ex.: /boleto) que ele sugere na hora.',
        'São textos prontos seus. Dá pra criar na hora pelo próprio raio, e gerenciar tudo em Configurações.',
      ],
    },
    {
      titulo: 'Mandar mídia e mais',
      icone: 'bi-paperclip',
      itens: [
        '*Clipe* — imagem, vídeo ou documento, até *25MB*.',
        '*Ctrl+V* — cola print/imagem direto no campo, sem precisar salvar arquivo.',
        '*Microfone* — grava áudio igual WhatsApp. No áudio recebido dá pra acelerar (1x → 1,5x → 2x).',
        '*Contato* — escolhe da sua agenda de contatos e manda o cartão (pede confirmação antes).',
        '*Localização* — pega a sua localização atual, mostra o mapa e confirma antes de enviar.',
      ],
    },
    {
      titulo: 'Em cima de uma mensagem',
      icone: 'bi-chat-square-dots',
      itens: [
        '*Responder* — no computador, passe o mouse na mensagem; no celular, *arraste pro lado* (ou segure pra abrir o menu).',
        '*Reagir* com emoji, *Copiar* texto e *Encaminhar* pra outra conversa (o Fio abre um buscador pra escolher o destino).',
        '*Editar* e *Apagar* valem só pras mensagens que você mandou — e o WhatsApp do cliente também mostra editada/apagada.',
        'Os ✓ dizem o estado: 🕐 enviando, ✓ enviada, ✓✓ entregue, ✓✓ azul-claro = o cliente leu.',
      ],
    },
    {
      titulo: 'Buscar dentro da conversa',
      icone: 'bi-search',
      itens: [
        'Lupa no cabeçalho da conversa: digita o termo e ele *pula de resultado em resultado*, destacando a mensagem.',
        'Útil pra achar aquele "combinado" antigo sem rolar a conversa inteira.',
      ],
    },
  ],

  acoes: [
    {
      titulo: 'Menu ⋮ (cabeçalho da conversa)',
      icone: 'bi-three-dots-vertical',
      tabela: [
        ['Fixar no topo', 'Prende a conversa no topo da lista. Bom pro caso que você está tocando agora.'],
        ['Marcar como não-lida', 'Acende a *bolinha laranja* na lista pra você lembrar de voltar. Não muda o dono da conversa e o cliente não fica sabendo.'],
        ['Assumir', 'Pega a conversa pra você sem precisar responder ainda.'],
        ['Transferir de canal', 'Manda pra fila de *outro número/canal* da empresa.'],
        ['Transferir de setor', 'Mesmo número, *outra fila* (ex.: Caixa → Crediário). É o que você usa quando o cliente errou o menu.'],
        ['Passar pra colega', 'Entrega a conversa pra uma pessoa específica da mesma fila. Mostra quem está 🟢 disponível, 🟡 ausente ou ⚪ offline.'],
        ['Devolver pro Pendente', 'Solta a conversa (fica sem dono) pra qualquer um da fila pegar.'],
        ['Encerrar', 'Fecha o atendimento: sai da sua fila e vai pras *Encerradas*. Pede o motivo só se a loja tiver ligado isso nas configurações.'],
      ],
    },
    {
      titulo: 'Qual usar em cada caso',
      icone: 'bi-signpost-split',
      itens: [
        'Cliente pediu assunto que não é meu → *Transferir de setor*.',
        'É do meu setor, mas de outra pessoa (ex.: quem já vinha atendendo) → *Passar pra colega*.',
        'Peguei sem querer / vou sair agora → *Devolver pro Pendente*.',
        'Resolvido → *Encerrar* com o motivo certo (o motivo alimenta os indicadores).',
        'Ainda vou resolver, mas depois → *Fixar* ou *Marcar como não-lida*.',
      ],
    },
    {
      titulo: 'Editar o contato',
      icone: 'bi-person-vcard',
      itens: [
        'Clique no *nome/foto do cliente* no cabeçalho: abre a lateral pra ajustar nome, filial e a fila padrão daquele contato.',
        'Vale pro próximo atendimento: da próxima vez que esse cliente falar, ele já entra na fila certa (ou direto com o atendente definido), sem passar pelo menu do bot.',
      ],
    },
  ],

  duvidas: [
    {
      titulo: 'Assumir, responder e o Pendente',
      icone: 'bi-headset',
      tabela: [
        ['Se eu responder, preciso clicar em Assumir antes?',
          'Não. Se a conversa não tem dono, *responder já assume* e ela passa pra sua "Minha fila". O botão Assumir serve pra dois casos: reservar a conversa sem responder agora, ou *transferir pra você* uma que já está com outra pessoa.'],
        ['Sou gerente/gestor: dá pra eu ajudar sem tomar a conversa da atendente?',
          'Dá, e é o comportamento padrão. Abra a conversa e responda: sua mensagem sai pro cliente e a conversa *continua com ela*, na fila dela — ela não perde nada de vista. A conversa só troca de dono se você clicar em *Assumir pra mim*, ou se usar *Passar pra colega* / *Devolver pro Pendente*.'],
        ['Por que uma conversa saiu do Pendente sem eu fazer nada?',
          'Porque ela deixou de ser pendência. *Pendente* significa duas coisas ao mesmo tempo: ninguém é dono dela *e* a última mensagem é do cliente. Ela sai dali quando alguém assume, quando o sistema distribui automaticamente, ou quando alguém responde ao cliente — inclusive pelo celular.'],
        ['O cliente voltou a falar depois de encerrado. Onde foi parar?',
          'Ela *reabriu sozinha*: soltou o atendente anterior, voltou pro Pendente e entrou de novo pela fila (passando pelo menu do bot, se o canal tiver um). Procure no *Pendente*, não nas Encerradas.'],
        ['Fiquei Ausente e voltei. Preciso pegar tudo na mão?',
          'Não. Ao voltar pra *Disponível*, o sistema puxa pra você os pendentes das suas filas automáticas, do mais antigo pro mais novo.'],
      ],
    },
    {
      titulo: 'Lido e não-lido: o Fio e o celular andam juntos',
      icone: 'bi-check2-all',
      itens: [
        'O Fio e o WhatsApp do aparelho estão *conectados nos dois sentidos*: o que você lê num, o outro fica sabendo em alguns segundos, sem precisar atualizar a página.',
        'Dois avisos diferentes indicam não-lida: o *número laranja* (quantas mensagens do cliente ainda não foram lidas) e a *bolinha laranja* (você marcou como não-lida de propósito, pra voltar depois).',
      ],
      tabela: [
        ['Abri a conversa no celular, mas não respondi. O que muda aqui?',
          'A conversa *continua na sua lista, no mesmo lugar de antes* — ela não sai de lugar nenhum. O que muda é só o aviso de não-lida: o número laranja *zera* e a conversa fica marcada como lida. Como você não respondeu, o cliente continua esperando: ela segue no *Pendente* e o cronômetro ⏱ continua correndo.'],
        ['Respondi o cliente pelo celular, fora do Fio. E agora?',
          'A sua mensagem *aparece aqui na conversa* normalmente, como se você tivesse mandado pelo Fio, e a conversa é marcada como lida. Como agora quem falou por último foi a loja, ela *sai do Pendente* (não é mais pendência) e passa a aparecer em *Ver junto → Por fora*, com o selo 📱. Volta pro Pendente assim que o cliente responder.'],
        ['Abri a conversa aqui no Fio. O cliente vê ✓✓ azul?',
          'Vê. Abrir a conversa no Fio *marca como lida no WhatsApp também*, exatamente como se você tivesse aberto no aparelho.'],
        ['Marquei como não-lida sem querer. Como desfaz?',
          'É só *abrir a conversa* — a bolinha laranja sai sozinha. Marcar como não-lida é só um lembrete visual pra você; não muda nada pro cliente nem tira a conversa de quem é dono dela.'],
      ],
    },
    {
      titulo: 'Contatos: a agenda do Fio e a do celular são separadas',
      icone: 'bi-person-vcard',
      itens: [
        'São *duas agendas diferentes*, e o WhatsApp não deixa uma enxergar a outra: quem você salva no aparelho o Fio não recebe (testado — não é bug nem configuração, o WhatsApp simplesmente não entrega a agenda do celular).',
        'Por isso a regra da casa é uma só: *salvar sempre pelo Fio*. Assim a agenda do Fio fica completa, e é dela que sai a exportação pro aparelho quando precisar. Salvar nos dois lugares só cria contato repetido.',
        'A agenda do Fio é *por canal*: cada número tem a sua. O mesmo cliente pode estar como "João Pedreiro" na agenda do Crediário e "João Obra Centro" na do vendedor — cada equipe procura pelo nome que ela usa, sem uma atrapalhar a busca da outra.',
      ],
      tabela: [
        ['Onde eu salvo um contato novo?',
          'Sempre pelo Fio, de dois jeitos: no *cartão de contato* que o cliente manda na conversa (botão *Salvar*), ou direto na tela de *Contatos*. Nos dois casos ele entra na agenda do canal em que você está.'],
        ['Salvei no celular e o nome não apareceu no Fio. Está quebrado?',
          'Não, é assim mesmo — o WhatsApp não compartilha a agenda do aparelho com nenhum sistema. O contato salvo no celular fica só no celular. Salve pelo Fio (ou cadastre aqui também) pra ele aparecer com nome nas duas pontas.'],
        ['E pra levar os contatos do Fio pro WhatsApp do celular?',
          'Em *Contatos → Exportar*. Ele gera um arquivo *.vcf* (o formato de agenda que o celular entende) só com os contatos salvos no Fio que ainda não foram pro aparelho. Você abre esse arquivo no celular e importa; o Android e o iPhone tratam ele como "adicionar contatos". Depois volte aqui e confirme em *Já importei no celular*, pra esses não virem de novo na próxima exportação.'],
        ['Preciso exportar todo dia?',
          'Não. Isso é pra momentos pontuais: trocar de aparelho, entrar alguém novo na equipe, ou alinhar as duas agendas. No dia a dia basta salvar pelo Fio — o atendimento inteiro funciona com a agenda daqui.'],
      ],
    },
    {
      titulo: 'Não estou achando a conversa',
      icone: 'bi-search',
      tabela: [
        ['A lista está vazia.',
          'Verifique, nesta ordem: (1) a *visão* — Minha fila, Pendente e Encerradas são listas diferentes; (2) os *filtros* de Fila e Canal, que ficam salvos de uma sessão pra outra e podem ter ficado ligados; (3) se você está *vinculado a um canal* — se não estiver, a tela avisa em amarelo e nada aparece.'],
        ['Sei que a conversa existe, mas não acho.',
          'Use a *busca do topo*: ela procura por nome, número e até por *texto de mensagem* dentro das conversas da visão em que você está. Se ainda não achar, o mais provável é que ela esteja encerrada (veja em *Encerradas*) ou numa fila que você não enxerga.'],
        ['Vejo a conversa mas não consigo digitar.',
          'Isso acontece quando a conversa é de um *canal* que você não atende — aí é bloqueio mesmo. Estar com outro *colega* não bloqueia nada: aparece um aviso laranja e você escreve normalmente, sem tirar a conversa dele.'],
      ],
    },
    {
      titulo: 'Quem configura o quê',
      icone: 'bi-gear',
      tabela: [
        ['O menu do bot',
          'Desenhado em *Fluxos do bot* (Flow Builder) e publicado por canal. Enquanto o canal não tiver um fluxo publicado, ninguém vê menu nenhum — as conversas caem direto na fila padrão do canal.'],
        ['Pra qual fila as conversas novas vão',
          'Na tela de *WhatsApp*, no campo *Fila padrão* do canal. É esse campo que decide onde a conversa entra. Sem ele, a conversa nasce *sem fila* e fica parada no Pendente até alguém puxar na mão.'],
        ['Se a fila entrega sozinha ou não',
          'Em *Atendimento → Filas*, no campo *Distribuição*: automática (entrega pro disponível menos carregado) ou manual (fica no Pendente e o time se serve). Isso só age *depois* que a conversa já entrou na fila.'],
        ['Quem enxerga cada fila',
          'Em *Usuários*: marque as filas que a pessoa vê e use a ⭐ pra definir a *fila principal* dela — é nela que cai a conversa quando ela assume algo que ainda não tinha fila.'],
        ['Horário e mensagens automáticas',
          'Em *Configurações*: horário de atendimento, a mensagem de boas-vindas do canal e a saudação de quando alguém assume.'],
      ],
    },
  ],
};

const ABAS = [
  { id: 'fluxo', label: 'Como a conversa chega', icone: 'bi-signpost-2' },
  { id: 'tela', label: 'A tela e os filtros', icone: 'bi-layout-sidebar-inset' },
  { id: 'selos', label: 'Selos e avisos', icone: 'bi-tags' },
  { id: 'responder', label: 'Atender e responder', icone: 'bi-chat-dots' },
  { id: 'acoes', label: 'Menu ⋮ e transferências', icone: 'bi-three-dots-vertical' },
  { id: 'duvidas', label: 'Dúvidas', icone: 'bi-question-circle' },
];

// -------------------------------------------------------------- fluxograma --

// Fluxo real do Fio, coluna unica com o desvio automatico/pendente.
function FluxogramaSVG() {
  const corProcBg = 'rgba(61, 139, 55, 0.18)';
  const corDecBg = 'rgba(245, 166, 35, 0.18)';
  const corLinha = 'rgba(255,255,255,0.45)';

  const Box = ({ x, y, w, h, label, fill, stroke, fs = 12 }) => {
    const linhas = label.split('\n');
    return (
      <g>
        <rect x={x} y={y} width={w} height={h} rx={10} ry={10} fill={fill} stroke={stroke} strokeWidth={1.5} />
        {linhas.map((linha, i) => (
          <text
            key={i}
            x={x + w / 2}
            y={y + h / 2 + (i - (linhas.length - 1) / 2) * (fs + 2.5)}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#fff"
            fontSize={fs}
            fontWeight={600}
          >
            {linha}
          </text>
        ))}
      </g>
    );
  };

  const seta = (x1, y1, x2, y2) => (
    <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={corLinha} strokeWidth={1.4} markerEnd="url(#seta)" />
  );

  return (
    <svg viewBox="0 0 320 600" width="100%" height="auto" preserveAspectRatio="xMidYMin meet">
      <defs>
        <marker id="seta" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
          <path d="M 0 0 L 10 5 L 0 10 z" fill={corLinha} />
        </marker>
      </defs>

      <Box x={55} y={8} w={210} h={38} label={'Cliente manda mensagem'} fill={corProcBg} stroke={VERDE} />
      {seta(160, 46, 160, 66)}

      <Box x={20} y={66} w={280} h={48} label={'Bot pergunta a fila (1 Caixa · 2 Crediário)\nsem bot → fila padrão do canal'} fill={corProcBg} stroke={VERDE} fs={11} />
      {seta(160, 114, 160, 134)}

      <Box x={45} y={134} w={230} h={40} label={'Entra na FILA (setor)'} fill={corDecBg} stroke={LARANJA} />
      {seta(160, 174, 160, 194)}

      <Box x={20} y={194} w={280} h={46} label={'Fila automática com alguém Disponível?'} fill={corDecBg} stroke={LARANJA} fs={11.5} />

      {/* ramos: sim (esquerda) / nao (direita) */}
      <path d="M 160 240 L 160 252 L 82 252 L 82 268" fill="none" stroke={corLinha} strokeWidth={1.4} markerEnd="url(#seta)" />
      <path d="M 160 240 L 160 252 L 238 252 L 238 268" fill="none" stroke={corLinha} strokeWidth={1.4} markerEnd="url(#seta)" />
      <text x={92} y={248} fontSize="10" fill="#fff" opacity="0.75">sim</text>
      <text x={214} y={248} fontSize="10" fill="#fff" opacity="0.75">não</text>

      <Box x={12} y={268} w={140} h={52} label={'Cai na MINHA FILA\ndo atendente'} fill={corProcBg} stroke={VERDE} fs={11} />
      <Box x={168} y={268} w={140} h={52} label={'Fica em PENDENTE\n(alguém pega)'} fill={corDecBg} stroke={LARANJA} fs={11} />

      <path d="M 82 320 L 82 338 L 160 338 L 160 352" fill="none" stroke={corLinha} strokeWidth={1.4} markerEnd="url(#seta)" />
      <path d="M 238 320 L 238 338 L 160 338" fill="none" stroke={corLinha} strokeWidth={1.4} />

      <Box x={35} y={352} w={250} h={48} label={'Atendente responde\n(responder já assume)'} fill={corProcBg} stroke={VERDE} fs={11.5} />
      {seta(160, 400, 160, 420)}

      <Box x={35} y={420} w={250} h={46} label={'Transfere · Passa pra colega · Devolve\nou Encerra com motivo'} fill={corProcBg} stroke={VERDE} fs={10.5} />
      {seta(160, 466, 160, 486)}

      <Box x={45} y={486} w={230} h={40} label={'Cliente volta → reabre'} fill={'rgba(255,255,255,0.08)'} stroke={'rgba(255,255,255,0.4)'} fs={11.5} />
      {/* volta pontilhada pro comeco do roteamento */}
      <path d="M 45 506 C 6 506 6 90 20 90" fill="none" stroke={corLinha} strokeWidth={1.2} strokeDasharray="4 3" markerEnd="url(#seta)" />

      <g transform="translate(8,552)">
        <rect width={14} height={14} rx={3} fill={corProcBg} stroke={VERDE} strokeWidth="1" />
        <text x={20} y={11} fontSize="11" fill="#fff">Passo</text>
        <rect x={78} width={14} height={14} rx={3} fill={corDecBg} stroke={LARANJA} strokeWidth="1" />
        <text x={98} y={11} fontSize="11" fill="#fff">Fila / decisão</text>
      </g>
    </svg>
  );
}

// ------------------------------------------------------------------ modal ---

function Bloco({ secao }) {
  return (
    <div style={{
      marginBottom: 12, padding: 12, borderRadius: 10,
      border: '1px solid var(--portal-border)',
      background: 'rgba(61, 139, 55, 0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 7 }}>
        <i className={`bi ${secao.icone}`} style={{ fontSize: '1.15rem', color: VERDE }} />
        <strong style={{ fontSize: '0.92rem' }}>{secao.titulo}</strong>
      </div>

      {secao.itens && (
        <ul style={{ paddingLeft: 20, marginBottom: 0, fontSize: '0.84rem', lineHeight: 1.55 }}>
          {secao.itens.map((linha, i) => (
            <li key={i} style={{ marginBottom: 4 }}><Rico texto={linha} /></li>
          ))}
        </ul>
      )}

      {secao.tabela && (
        <div style={{ display: 'grid', gap: 1 }}>
          {secao.tabela.map(([chave, valor], i) => (
            <div
              key={i}
              style={{
                display: 'grid',
                gridTemplateColumns: 'minmax(120px, 34%) 1fr',
                gap: 10,
                padding: '7px 2px',
                borderTop: i === 0 ? 'none' : '1px solid var(--portal-border)',
                fontSize: '0.84rem',
                lineHeight: 1.5,
              }}
            >
              <div style={{ fontWeight: 700 }}>{chave}</div>
              <div><Rico texto={valor} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FluxoModal({ aberto, onClose }) {
  const [aba, setAba] = useState('fluxo');
  if (!aberto) return null;
  const secoes = SECOES[aba] || [];
  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.7)' }}>
      <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
        <div className="modal-content" style={{ background: 'var(--portal-surface)', color: 'var(--portal-text)' }}>
          <div className="modal-header" style={{ borderColor: 'var(--portal-border)' }}>
            <h5 className="modal-title">
              <i className="bi bi-info-circle me-2" />
              Como funciona o atendimento
            </h5>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div className="modal-body" style={{ maxHeight: '78vh', overflowY: 'auto' }}>
            <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 10 }}>
              O cliente fala no WhatsApp, a conversa cai numa fila, alguém assume e responde por aqui.
              Abaixo, o passo a passo e o que cada botão da tela faz.
            </p>

            {/* Abas */}
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
              {ABAS.map((a) => {
                const ativa = aba === a.id;
                return (
                  <button
                    key={a.id}
                    type="button"
                    onClick={() => setAba(a.id)}
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 6,
                      fontSize: '0.78rem', fontWeight: ativa ? 700 : 500,
                      padding: '6px 11px', borderRadius: 8, cursor: 'pointer',
                      border: '1px solid var(--portal-border)',
                      background: ativa ? VERDE : 'transparent',
                      color: ativa ? '#fff' : 'var(--portal-text)',
                    }}
                  >
                    <i className={`bi ${a.icone}`} />{a.label}
                  </button>
                );
              })}
            </div>

            <div className="row g-3">
              <div className={aba === 'fluxo' ? 'col-12 col-lg-7' : 'col-12'}>
                {secoes.map((secao, idx) => <Bloco key={idx} secao={secao} />)}
              </div>

              {aba === 'fluxo' && (
                <div className="col-12 col-lg-5">
                  <div style={{
                    padding: 12, borderRadius: 10,
                    border: '1px solid var(--portal-border)',
                    background: 'rgba(0,0,0,0.18)',
                    position: 'sticky', top: 0,
                  }}>
                    <div style={{ fontSize: '0.82rem', color: 'var(--portal-muted)', marginBottom: 8, textAlign: 'center' }}>
                      O caminho da conversa
                    </div>
                    <FluxogramaSVG />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer" style={{ borderColor: 'var(--portal-border)' }}>
            <button className="btn btn-outline-secondary" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Botao "i" + modal autocontido. Renderize ao lado do titulo da pagina de Atendimentos.
export default function InfoFluxoAtendimento() {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        title="Como funciona o atendimento"
        aria-label="Como funciona o atendimento"
        style={{
          background: 'transparent',
          border: '1px solid var(--portal-border)',
          color: VERDE,
          width: 30, height: 30, borderRadius: '50%',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', fontSize: '1rem',
        }}
      >
        <i className="bi bi-info-lg" />
      </button>
      <FluxoModal aberto={aberto} onClose={() => setAberto(false)} />
    </>
  );
}
